/* eslint-disable max-len */
// Dependencies
import React, {useState} from 'react'
import {connect} from 'react-redux'
import firebase from 'firebase/compat/app'

// Actions
import {storePayload} from '../actions/storePayload'
import {signIn} from '../actions/signIn'
import {enterMFACode} from '../actions/enterMFACode'

// Styles
import '@lazarusai/forms-ui-components/dist/index.css'
import styles from '../styles/Authentication.module.css'

// Images
import AuthBackground from '../images/AuthBackground.png'
import ATLSLogo from '../images/ATLS.svg'
import LazarusName from '../images/LazarusName.svg'

// Components
import {Button, Input, Icon} from '@lazarusai/forms-ui-components'

function Authentication(props) {
  const [passwordInput, setPasswordInput] = useState('')
  const [userNameInput, setUserNameInput] = useState('')
  const [mfaCode, setMfaCode] = useState('')
  const [demoChoice, setDemoChoice] = useState('')

  function onClickForgotPassword(e) {
    e.stopPropagation()
    if (userNameInput) {
      firebase
          .auth()
          .sendPasswordResetEmail(userNameInput)
          .then((res) => {
            props.storePayload({
              userMessage: 'Please check your email to change your password.',
              notificationType: 1,
              notificationIcon: 'check',
            })
          })
          .catch((err) => {
            props.storePayload({
              userMessage: 'Email not found. Please try again.',
              notificationType: 2,
              notificationIcon: 'warning',
            })
          })
    } else {
      props.storePayload({
        userMessage: 'Please include your email.',
        notificationType: 2,
        notificationIcon: 'warning',
      })
    }
  }

  return (
    <div
      className={styles['auth-wrapper']}
      id={props.id || ''}
      style={props.style || {}}
    >
      <div
        className={styles['auth-background-wrapper']}
      >
        <img
          className={styles['auth-background-image']}
          src={AuthBackground}
        />
      </div>
      <div
        className={styles['auth-inputs-wrapper']}
      >
        <div
          className={styles['auth-inputs']}
        >
          <div
            className={styles['auth-logo-wrapper']}
          >
            <img
              className={styles['auth-logo']}
              src={ATLSLogo}
            />
          </div>
          <div
            className={styles['auth-body-wrapper']}
          >
            <div
              className={styles['auth-body']}
            >
              <div
                className={`${styles['auth-left']} ${styles['auth-side']}`}
              >
                <img
                  src={LazarusName}
                  className={styles['lazarus-logo']}
                />
                <div
                  className={styles['main-text']}
                >
                  We build AI to help people solve the world&apos;s toughest problems
                </div>
                <div
                  className={styles['bottom-text']}
                >
                  {/* BOTTOM TEXT */}
                </div>
              </div>
              <div
                className={`${styles['auth-right']} ${styles['auth-side']}`}
              >
                {props.isMFANeeded ?
                  <>
                    {/* MFA */}
                    <div
                      className={styles['main-text']}
                    >
                      Enter code from your authentication app
                    </div>
                    <form
                      className={styles['mfa-input-wrapper']}
                      onSubmit={(e) => {
                        e.preventDefault()
                        props.enterMFACode(mfaCode.slice(0, 6), props.mfaError)
                      }}
                    >
                      <input
                        className={styles['mfa-input']}
                        type={'number'}
                        onChange={(e) => {
                          setMfaCode(e.target.value.slice(0, 6))
                        }}
                      />
                      {new Array(6).fill(0).map((_val, index) => {
                        return (
                          <div
                            key={`mfa-input-${index}`}
                            className={styles['mfa-value']}
                          >
                            {mfaCode.length <= 0 ?
                              '_' :
                              mfaCode[index]
                            }
                          </div>
                        )
                      })}
                    </form>
                    <div
                      className={styles['bottom-text']}
                    >
                      Need help?
                    </div>
                  </> :
                  !props.isFirebaseSignedIn ?
                    <>
                      {/* SIGN IN */}
                      <Input
                        theme={props.theme}
                        className={styles['sign-in-input']}
                        placeholder={'Username'}
                        value={userNameInput}
                        onChange={(e) => {
                          setUserNameInput(e.target.value)
                        }}
                      />
                      <Input
                        theme={props.theme}
                        className={styles['sign-in-input']}
                        placeholder={'Password'}
                        value={passwordInput}
                        onChange={(e) => {
                          setPasswordInput(e.target.value)
                        }}
                        inputType={'password'}
                      />
                      <div
                        className={styles['sign-in-bottom']}
                      >
                        <div
                          className={`${styles['forgot-password']} ${styles['cursor-pointer']}`}
                          onClick={onClickForgotPassword}
                        >
                          Forgot password?
                        </div>
                        <Button
                          theme={props.theme}
                          text={'Sign In'}
                          className={`${styles['sign-in-button']} ${(passwordInput?.length && userNameInput?.length) ? '': styles['hidden']}`}
                          icon={<Icon icon='arrow-forward-outline'/>}
                          iconPosition={'right'}
                          onClick={(e) => {
                            e.preventDefault()
                            props.signIn(
                                userNameInput,
                                passwordInput,
                                props.database,
                            )
                          }}
                        />
                      </div>
                    </> :
                    <>
                      {/* SELECT DEMO */}
                      <div
                        className={`${styles['main-text']} ${styles['choose-demo']}`}
                      >
                        Choose a demo
                      </div>
                      <Input
                        type={3}
                        theme={props.theme}
                        className={styles['sign-in-input']}
                        options={['Insurance', 'potato']}
                        placeholder={'Select'}
                        value={demoChoice}
                        onChange={(e) => {
                          setDemoChoice(e.target.value)
                        }}
                      />
                      <Button
                        theme={props.theme}
                        text={'Continue'}
                        className={`${styles['sign-in-button']} ${styles['choice-button']} ${(demoChoice) ? '': styles['hidden']}`}
                        onClick={(e) => {
                          props.storePayload({
                            demoType: demoChoice,
                            isSignedIn: true,
                          })
                        }}
                      />
                    </>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => ({
  theme: state.userReducer.theme,
  cookies: ownProps.cookies,
  storage: state.firebaseReducer.storage,
  database: state.firebaseReducer.database,
  firestore: state.firebaseReducer.firestore,
  userMessage: state.userReducer.userMessage,
  notificationType: state.userReducer.notificationType,
  notificationIcon: state.userReducer.notificationIcon,
  lang: state.userReducer.lang,
  isSignedIn: state.userReducer.isSignedIn,
  isFirebaseSignedIn: state.userReducer.isFirebaseSignedIn,
  isMFANeeded: state.userReducer.isMFANeeded,
  mfaError: state.userReducer.mfaError,
})

export default connect(
    mapStateToProps,
    {storePayload, signIn, enterMFACode},
)(Authentication)
